// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__197rr","footer":"styles_footer__3S4Oa","passCodeTooltip":"styles_passCodeTooltip__iHWvh"};